import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b314ee18")

_pushScopeId("data-v-b314ee18")
const _hoisted_1 = { class: "px-5 py-3 flex flex-row justify-between items-center rounded-xl footer-section" }
const _hoisted_2 = { class: "flex flex-row items-center gap-6" }
const _hoisted_3 = { class: "flex flex-row items-center gap-2" }
const _hoisted_4 = { class: "flex flex-row items-center gap-4" }
const _hoisted_5 = { class: "text-sm text-gray-lp-300 font-medium" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_weight_cost = _resolveComponent("weight-cost")!
  const _component_check_tariff_v2 = _resolveComponent("check-tariff-v2")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_LpButton, {
          title: _ctx.$t('bulkBooking.deleteBooking'),
          textColor: "red-lp-100",
          outline: "",
          fontWeight: "semibold",
          onClick: _ctx.onConfirmDeleteSttRepair
        }, null, 8, ["title", "onClick"]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_weight_cost, {
            formType: _ctx.formType,
            totalItem: _ctx.totalItem,
            totalGrossWeight: _ctx.totalGrossWeight,
            totalDimensionWeight: _ctx.totalDimensionWeight,
            chargeableWeight: _ctx.estimationPrice.chargeableWeight,
            isVolumeWeight: _ctx.isVolumeWeight,
            isCampaign: _ctx.isCampaign,
            isGrossWeight: _ctx.isGrossWeight
          }, null, 8, ["formType", "totalItem", "totalGrossWeight", "totalDimensionWeight", "chargeableWeight", "isVolumeWeight", "isCampaign", "isGrossWeight"]),
          _createVNode(_component_check_tariff_v2, {
            modelValue: _ctx.form,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form = $event)),
            isBooking: true,
            isDisabled: _ctx.isDisabled,
            bookingType: _ctx.formType,
            payload: _ctx.payload,
            accountRefAndCommodity: _ctx.accountRefAndCommodity,
            formType: _ctx.formType,
            discountData: _ctx.discount,
            isCodRetail: _ctx.isCodRetailApplied,
            goodsValue: _ctx.goodsValue,
            onUpdateStatusErrorEmbargo: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('updateStatusErrorEmbargo'))),
            clientIdFromShipment: _ctx.clientIdFromShipment,
            isInternational: _ctx.form.isInternational,
            destinationCurrencyPrefix: _ctx.destinationCurrencyPrefix,
            destinationCurrencyLocale: _ctx.destinationCurrencyLocale,
            isCrossCountryCod: _ctx.isCrossCountryCod,
            prefixCurrency: _ctx.prefixCurrency
          }, null, 8, ["modelValue", "isDisabled", "bookingType", "payload", "accountRefAndCommodity", "formType", "discountData", "isCodRetail", "goodsValue", "clientIdFromShipment", "isInternational", "destinationCurrencyPrefix", "destinationCurrencyLocale", "isCrossCountryCod", "prefixCurrency"])
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.repairPosition), 1),
        _createVNode(_component_LpButton, {
          title: _ctx.$t('bulkBooking.booking'),
          textColor: "white",
          fontWeight: "semibold",
          icon: "ics_f_arrow-circle-right",
          onClick: _ctx.onBookingSttRepair
        }, null, 8, ["title", "onClick"])
      ])
    ]),
    (_ctx.messageModal)
      ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 0 }, _ctx.messageEntities), null, 16))
      : _createCommentVNode("", true)
  ], 64))
})